import type { TableColumns } from '@ohpen/enso-ui';
import { FirmGetAllResponse, FieldType, LenderFirmDraftDataRow } from '@pmp/api';

export const columns: TableColumns<FirmGetAllResponse> = [
  {
    title: 'lender.firms.labels.ohpenId',
    dataIndex: 'ohpenId',
    key: 'id',
    width: 300,
    fixed: 'left',
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'lender.firms.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 300,
    fixed: 'left',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.firms.labels.isAuthorised',
    dataIndex: 'isAuthorised',
    key: 'isAuthorised',
    width: 140,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
      hide: true,
    },
  },
  {
    title: 'lender.firms.labels.reference',
    dataIndex: 'reference',
    key: 'reference',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'lender.firms.labels.type',
    dataIndex: 'type',
    key: 'type',
    width: 120,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.FIRM_TYPE,
      sorter: true,
    },
  },
  {
    title: 'lender.firms.labels.frn',
    dataIndex: 'frn',
    key: 'frn',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.firms.labels.nacfbNumber',
    dataIndex: 'nacfbNumber',
    key: 'nacfbNumber',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'lender.firms.labels.fcaStatus',
    dataIndex: 'fcaStatus',
    key: 'fcaStatus',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.firms.labels.principalFirm',
    dataIndex: 'principalFirm',
    key: 'principalFirm',
    width: 200,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.PRINCIPALS,
      hide: true,
    },
  },
  {
    title: 'lender.firms.labels.operations',
    dataIndex: 'operationsWhitelist',
    key: 'operationsWhitelist',
    width: 120,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.OPERATION_TYPE,
    },
  },
  {
    title: 'lender.firms.labels.btl',
    dataIndex: 'btl',
    key: 'btl',
    width: 80,
    options: {
      format: { type: 'valueList' },
      filter: 'select',
      listName: FieldType.CASE_PERMISSION_TYPE,
    },
  },
  {
    title: 'lender.firms.labels.rbtl',
    dataIndex: 'rbtl',
    key: 'rbtl',
    width: 80,
    options: {
      format: { type: 'valueList' },
      filter: 'select',
      listName: FieldType.CASE_PERMISSION_TYPE,
    },
  },
  {
    title: 'lender.firms.labels.rmc',
    dataIndex: 'rmc',
    key: 'rmc',
    width: 80,
    options: {
      format: { type: 'valueList' },
      filter: 'select',
      listName: FieldType.CASE_PERMISSION_TYPE,
    },
  },
  {
    title: 'lender.firms.labels.firmCompliance',
    dataIndex: 'firmCompliance',
    key: 'complianceStatus',
    width: 120,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.COMPLIANCE_STATUS,
    },
  },
  {
    title: 'lender.firms.labels.isActive',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 120,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
    },
  },
  {
    title: 'lender.firms.labels.defaultPaymentRoute',
    dataIndex: 'defaultPaymentRouteFirm',
    key: 'defaultPaymentRouteFirm',
    width: 180,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.FIRMS,
      sorter: true,
    },
  },
  {
    title: 'lender.firms.labels.activationDate',
    dataIndex: 'activationDate',
    key: 'activationDate',
    width: 120,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'lender.firms.labels.deactivationDate',
    dataIndex: 'deactivationDate',
    key: 'deactivationDate',
    width: 120,
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      sorter: true,
      hide: true,
    },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 80, fixed: 'right' },
];

export const lenderFirmCRColumns: TableColumns<LenderFirmDraftDataRow> = [
  {
    title: 'lender.firms.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 200,
    options: {
      sorter: true,
    },
  },
  {
    title: 'lender.firms.labels.type',
    dataIndex: 'type',
    key: 'type',
    width: 120,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.FIRM_TYPE,
      sorter: true,
    },
  },
  {
    title: 'lender.firms.labels.isActive',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 120,
    options: {
      format: {
        type: 'boolean',
      },
      filter: 'select',
      listName: FieldType.YES_NO,
    },
  },
  {
    title: 'lender.firms.labels.reference',
    dataIndex: 'reference',
    key: 'reference',
    width: 120,
    options: {
      sorter: true,
    },
  },
  {
    title: 'lender.firms.labels.frn',
    dataIndex: 'frn',
    key: 'frn',
    width: 120,
    options: {
      sorter: true,
    },
  },
];
